import {Injectable} from '@angular/core';
import {EntityState, EntityStore, Store, StoreConfig} from '@datorama/akita';
import {createInitialState, Session} from './session.model';


@Injectable({providedIn: 'root'})
@StoreConfig({name: 'session'})
export class SessionStore extends Store<Session> {


	constructor() {
        super(createInitialState());
    }

}
